import React from "react";
import styled from "styled-components";

const TabsItem = (props: any, active: boolean) => {
  const { onClick, children } = props;

  return (
    <li
    className={`tabs__item ${props.className}`}
    style={{
      fontSize: "0.9rem",
      borderBottom: `${props.active === true ? "1px solid red" : "none"}`,
      padding: 0,
      marginRight:'1rem'
    }}
      onClick={onClick}
    >
      {children}
    </li>
  );

  const Item = styled.div``;
};

export default TabsItem;
